'use client';

import { LogoBjLink } from '@components/layout';

/**
 * @description Login Header
 * - This component is used in the login page.
 */
export const AuthHeader = () => (
  <div className="flex justify-start h-8 mt-3 mb-4 md:mb-6 md:mt-5 2xl:mb-9 2xl:mt-8">
    <LogoBjLink
      className="w-auto h-8"
      showFullLogo
    />
  </div>
);
